/**
 * SectionCard — Full-width card section with bottom border
 * Used in Profile-style screens where sections stack vertically
 */

import React from 'react';
import { Box, VStack, Text } from '@gluestack-ui/themed';
import { useDisplayTheme } from '../../hooks/useDisplayTheme';

const BASE_HEADING_SIZE = 16;

interface SectionCardProps {
  children: React.ReactNode;
  title?: string;
  /** Padding token, defaults to "$4" */
  p?: string;
  /** VStack spacing, defaults to "xl" (20px — matches inter-section gap) */
  space?: string;
  testID?: string;
}

export function SectionCard({
  children,
  title,
  p = '$4',
  space = 'xl',
  testID,
}: SectionCardProps) {
  const { theme: t, fontScale, ffs } = useDisplayTheme();

  return (
    <Box
      testID={testID}
      // eslint-disable-next-line @typescript-eslint/no-explicit-any -- Gluestack spacing tokens are narrowly typed
      p={p as any}
      mx="$4"
      mb="$3"
      rounded="$xl"
      style={{
        backgroundColor: t.card,
      }}
    >
      {/* eslint-disable-next-line @typescript-eslint/no-explicit-any -- Gluestack spacing tokens are narrowly typed */}
      <VStack space={space as any}>
        {title && (
          <Text
            allowFontScaling={false}
            accessibilityRole="header"
            style={{ fontSize: BASE_HEADING_SIZE * fontScale, fontWeight: 'bold', color: t.text, ...ffs }}
          >
            {title}
          </Text>
        )}
        {children}
      </VStack>
    </Box>
  );
}
